<template>
  <div>
    <div id="change-pass">
      <v-parallax height="auto" src="@/assets/images/back-page.webp">
        <v-container>
          <v-row>
            <v-col>
              <div class="webform">
                <h3 class="text-center">{{ title }}</h3>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-row justify="center" class="0">
                        <v-col cols="12" sm="7" md="6" lg="5" class="pa-0">
                          <div class="card-login pa-0" ref="form">
                            <v-card-text class="pa-0">
                              <v-text-field
                                ref="password"
                                name="password"
                                label="Contraseña"
                                class="mx-0 my-0"
                                filled
                                placeholder="Ingresa acá una nueva contraseña de 8 caracteres"
                                v-model="password"
                                hint="Obligatorio"
                                persistent-hint
                                required
                                :error-messages="passwordErrors"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                                @input="$v.password.$touch()"
                                @blur="$v.password.$touch()"
                              />
                              <password-meter :password="password"/>
                              <v-text-field
                                label="Confirmar contraseña"
                                class="ma-0 pt-3"
                                filled
                                placeholder="Repite acá la nueva contraseña"
                                v-model="confirmPassword"
                                hint="Obligatorio"
                                persistent-hint
                                required
                                :error-messages="confirmPasswordErrors"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                                @input="$v.confirmPassword.$touch()"
                                @blur="$v.confirmPassword.$touch()"
                              />
                            </v-card-text>
                            <p class="error" v-if="remoteError">{{ remoteError }}</p>
                            <v-card-actions class="text-center">
                              <v-btn color="info" :loading="loading" button @click="register" :disabled="$v.$invalid || loading" class="btn-main-job">ENVIAR</v-btn>
                            </v-card-actions>                            
                            <div class="write-us">
                              <p>Recibirás un correo con la confirmación <br>que creaste una nueva contraseña.</p>
                              <p>Si tienes problemas escríbenos directamente a <a href="mailto:hola@trabajoconsentido.com">hola@trabajoconsentido.com</a></p>
                            </div>
                            
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-parallax>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import passwordMeter from "vue-simple-password-meter";
import { meta } from "@/libs/mixins";

export default {
    name: "UpdatePassword",

    props: ["type", "token"],

    components: { passwordMeter },

    mixins: [validationMixin, meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Actualizar contraseña",
        });
    }, 

    data() {
        return {
            password: "",
            confirmPassword: "",
            showPassword: false,
            errors: [],
            loading: false
        };
    },

    computed: {
        remoteError() {
            let err = "";
            if (this.errors.length > 0)
                err = this.errors[this.errors.length - 1];
            return err;
        },
        passwordErrors() {
            const errors = [];
            if (!this.$v.password.$dirty) return errors;
            !this.$v.password.minLength && errors.push("Password debe tener al menos 8 caracteres");
            !this.$v.password.required && errors.push("Password es requerido");
            return errors;
        },
        confirmPasswordErrors() {
            const errors = [];
            if (!this.$v.confirmPassword.$dirty) return errors;
            !this.$v.confirmPassword.sameAsPassword && errors.push("Password deben ser iguales");
            return errors;
        },
        title() {
            let title = "Cambia tu contraseña";
            if (this.type != "change")
                title = "Crea tu contraseña";
            return title;
        }
    },

    methods: {
        register() {
            this.loading = true;
            this.$store
                .dispatch("users/updatePassword", {
                    token: this.token,
                    type: this.type,
                    password: this.password
                })
                .then(() => {
                    this.loading = false;
                    this.$router.push({ name: "RedirectionRule" });
                })
                .catch(err => {
                    this.loading = false;
                    this.errors = err;
                });
        }
    },

    validations: {
        password: { required, minLength: minLength(8) },
        confirmPassword: { sameAsPassword: sameAs("password") }
    },
};
</script>
